import React, { FC } from 'react';

import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import styles from './AlertDialog.module.scss';

interface AlertDialogProps {
  title: string;
  message: string;
  onClose: () => void;
}

const AlertDialog: FC<AlertDialogProps> = (
  {
    title,
    message,
    onClose,
  }
) => (
  <div className={styles.AlertDialog} data-testid="AlertDialog">
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>OK</Button>
      </DialogActions>
    </Dialog>
  </div>
);

export default AlertDialog;
